import 'font-awesome/css/font-awesome.min.css'
import Vue from 'vue'
import {
  Vuetify,
  VApp,
  VNavigationDrawer,
  VFooter,
  VList,
  VBtn,
  VIcon,
  VGrid,
  VToolbar,
  transitions,
  VTextField,
  VForm,
  VSelect,
  VDivider,
  VDialog,
  VDataTable,
  VCheckbox,
  VTabs,
  VAutocomplete,
  VDatePicker,
  VMenu,
  VTooltip,
  VSnackbar,
  VProgressCircular,
  VTextarea,
  VRadioGroup,
  VSpeedDial
} from 'vuetify'

import VCard from 'vuetify/es5/components/VCard'
import 'vuetify/src/stylus/app.styl'

Vue.use(Vuetify, {
  options: {
    customProperties: true
  },
  components: {
    VApp,
    VNavigationDrawer,
    VFooter,
    VList,
    VBtn,
    VIcon,
    VGrid,
    VToolbar,
    transitions,
    VTextField,
    VCard,
    VForm,
    VDivider,
    VDialog,
    VDataTable,
    VCheckbox,
    VTabs,
    VSelect,
    VAutocomplete,
    VDatePicker,
    VMenu,
    VTooltip,
    VSnackbar,
    VProgressCircular,
    VTextarea,
    VRadioGroup,
    VSpeedDial
  },
  theme: {
    primary: '#455a64',
    secondary: '#ff4081',
    lprimary: '#718792',
    lsecondary: '#ff79b0',
    dprimary: '#1c313a',
    dsecondary: '#c60055',
    lightgray: '#F5F5F6',
    darkgray: '#E1E2E1',
    accent: '#82B1FF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107'
  },
  icons: {
    iconfont: 'fa4',
  }
})

/*
<color name="primaryColor">#455a64</color>
  <color name="primaryLightColor">#718792</color>
  <color name="primaryDarkColor">#1c313a</color>
  <color name="secondaryColor">#ff4081</color>
  <color name="secondaryLightColor">#ff79b0</color>
  <color name="secondaryDarkColor">#c60055</color>
  <color name="primaryTextColor">#ffffff</color>
  <color name="secondaryTextColor">#000000</color>
 */
